import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import {
  useNavigate,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { Resizable } from "re-resizable";
import useIdle from "hooks/useIdle";

import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Fab,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Avatar,

} from "@mui/material";
import {
  useForm as useLightForm,
  useLLM,
  useSelectedOrganization,
  useSnackbar,
  useTranslations,
  useDepublishWithWarning,
} from "hooks";
//@ts-ignore
import { getBusinessObject } from "bpmn-js/lib/util/ModelUtil";
//@ts-ignore
import "bpmn-js/dist/assets/diagram-js.css";
//@ts-ignore
import "bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css";
// import "bpmn-js-properties-panel/dist/assets/properties-panel.css";
//@ts-ignore
import "bpmn-js/dist/assets/bpmn-js.css";
//@ts-ignore
import ContextPadProvider from "bpmn-js/lib/features/context-pad/ContextPadProvider";
//@ts-ignore
import "diagram-js-minimap/assets/diagram-js-minimap.css";
import {
  SaveOutlined,
  SaveAsOutlined,
  VerifiedOutlined,
  CloudDownloadOutlined,
  CloudUploadOutlined,
  CloudDoneOutlined,
  // ChevronLeft,
  Settings,
  ImportExport,
  DatasetLinkedOutlined,
  Visibility,
  VisibilityOff,
  Close,
  ErrorOutline,
  PersonOutline,
} from "@mui/icons-material";
import UserModel from "model/userModel";
//@ts-ignore
import "./NewProcessModule.css";
import {
  AssociationResponse,
  ExtensionElements,
  ExtensionElementType,
  // ProcessModelType,
} from "../../../../../model/processModel";
import PropertiesView from "./PropertyPanelEditor";
import useBpmnModeler from "../../../../../hooks/useBpmnModeler";
import SaveProcessModelPopUp from "../../components/SaveProcessModelPopUp";
import DropZoneElement from "./DropZoneElement";
import OrganizationPanel from "./OrganizationPanel";
import DialogHeader from "components/dialogs/DialogHeader";
import { Validation, isRequired } from "hooks/useForm";
import { CONSTANTS, getTranslation, create_UUID } from "common";
import { organizationsApi, processmodelsApi } from "api";
import { AssociationDialog, ProcessModelError } from "components";
import InputPopUp from "components/dialogs/InputPopUp";
import { clearLanes } from "common/utilities";
import { Robot } from "hooks/useRobots";
import { ProcessModelSchema } from "components/dialogs";
import type { FieldDefinition } from "model/CustomFields";
import {
  rowsToFields,
  toLegacySchema,
  type LegacySchemaRow,
} from "components/custom-fields/legacyAdapter";
import type { ElementChoice } from "components/custom-fields/visibilityImpact";
import ImpactDialog from "components/custom-fields/ImpactDialog";
import { messageKeyFor } from "components/custom-fields/errorMessages";
import { embedSchema, readSchema } from "components/custom-fields/schemaTransport";
import { newModelSchemaCommand } from "components/custom-fields/modelSchemaCommand";
import { isInCardOnlyChange } from "components/custom-fields/schemaDraft";
import { apiError, customFieldsApi } from "api/customFieldsApi";
import type { ImpactResult, SchemaDocument } from "model/CustomFields";
import AiDrawer from "components/aiChat/AiDrawer";
import AiFab from "components/aiChat/AiFab";
import useSubscriptionFeatures from "hooks/useSubscriptionFeatures";
import { Save } from "@mui/icons-material";
import useEditingState from "hooks/useEditingState";
import { useSelector } from "react-redux";
import { RootState } from "store";
import {
  SlaModelDraftProvider,
  SlaModelSaveProvider,
  useSlaModelDraft,
} from "components/sla/slaModelDraftContext";
export interface UsersOfSelectedOrganization extends UserModel {
  id: number;
}

export interface GroupModel {
  idorganization: number;
  id: number;
  icon: string | null;
  name: string;
}

export interface RolesModel {
  name: string;
  id: number;
  icon: string | null;
  idorganization: number;
}

const _getContextPadEntries = ContextPadProvider.prototype.getContextPadEntries;
ContextPadProvider.prototype.getContextPadEntries = function (element: any) {
  const entries = _getContextPadEntries.apply(this, [element]);
  // yet to be determined
  delete entries["lane-divide-three"];
  delete entries["lane-divide-two"];

  return entries;
};

// Larghezza del pannello proprieta': chiuso mostra solo il Fab; aperto usa
// 520px, ridotti al 45% della viewport (il canvas resta >= ~metà) ma mai
// sotto 360px, cosi' editor di processo e sezione SLA restano leggibili.
const PROPERTY_PANEL_CLOSED_WIDTH = 80;
const PROPERTY_PANEL_OPEN_WIDTH = 520;
const PROPERTY_PANEL_MIN_OPEN_WIDTH = 360;
const getPropertyPanelOpenWidth = () =>
  Math.max(
    PROPERTY_PANEL_MIN_OPEN_WIDTH,
    Math.min(PROPERTY_PANEL_OPEN_WIDTH, Math.round(window.innerWidth * 0.45))
  );

const removeFormat = (xml: string) =>
  xml.replace(/\n|\t/g, '').replace(/>\s+</g, '><').trim();

const generateUniqueName = (baseName: string, existingNames: string[]): string => {
  if (!existingNames.includes(baseName)) {
    return baseName;
  }

  let counter = 1;
  let newName = `${baseName} (${counter})`;

  while (existingNames.includes(newName)) {
    counter++;
    newName = `${baseName} (${counter})`;
  }

  return newName;
};

const NewProcessModule: React.FC = () => {
  const [selectedError, setSelectedError] = useState<number | null>(null);
  const isEditing = useEditingState();
  const navigate = useNavigate();
  const { sendSnack } = useSnackbar();
  const [openSaveAsDialog, setOpenSaveAsDialog] = useState(false);
  const [modelType, setModelType] = useState<number>(0);
  const published = modelType === 1;
  const organization = useSelectedOrganization();
  // NOTE: inOrder to call depublishing api we need to use a ref because we are using this api in an event listener of BPMNJS
  // const modelTypeRef = useRef<any>(true);
  const translations = useTranslations();
  const validations: Validation[] = [
    ({ saveAsName }) =>
      isRequired(saveAsName) || {
        saveAsName: getTranslation(translations, "required"),
      },
  ];
  const {
    values,
    changeHandler,
    isValid,
    errors: lightErrors,
    touched,
  } = useLightForm(
    {
      saveAsName: "",
    },
    validations
  );
  const [errors, setErrors] = useState<any | undefined>([]);
  const [isOverlapChecked, setIsOverlapChecked] = useState<boolean>(false);

  const { pathname, state } = useLocation();
  const { editId } = useParams();
  const [searchParams] = useSearchParams();
  // Lo stato e' nel contratto. Il confine di caricamento proietta la riga
  // legacy, quello di salvataggio la riproietta: la master non vede mai la
  // forma vecchia, che conosce quattro tipi e nessuna configurazione.
  const [schema, setSchema] = useState<FieldDefinition[]>([]);

  /**
   * Il salvataggio dello schema, quando c'e' un impatto da mostrare.
   *
   * Lo schema **non** si salva in silenzio: una modifica che nasconde un campo
   * a chi lo stava compilando, o che rende obbligatorio qualcosa che nessuno ha,
   * va vista prima. E il salvataggio resta sospeso finche' non e' confermata:
   * `pendingSchema` e' cio' che si applica dopo il consenso.
   */
  const [impatto, setImpatto] = useState<ImpactResult | null>(null);
  const [impattoLoading, setImpattoLoading] = useState(false);
  /**
   * Un salvataggio alla volta.
   *
   * La revisione attesa si legge all'inizio del flusso (`getSchema`): due
   * salvataggi sovrapposti partirebbero con la stessa, e il secondo verrebbe
   * rifiutato dal server con un conflitto di revisione. La guardia non e' un
   * retry: il secondo tentativo semplicemente non parte.
   */
  const salvataggioInCorso = useRef(false);
  const [pendingSchema, setPendingSchema] = useState<{
    rows: FieldDefinition[];
    operationId: string;
    documento: SchemaDocument;
  } | null>(null);
  const [mode, setMode] = useState<"create" | "edit">(() => {
    return pathname.includes("insert") ? "create" : "edit";
  });
  const { aiRequestCanUse, bypassSubscription, checkLoading, refreshSubscriptionFeatures } = useSubscriptionFeatures();
  const [shouldShowFlowNodeEditor, setShouldShowFlowNodeEditor] =
    useState<boolean>(false);

  const [processModelId, setProcessModelId] = useState<number | null>()

  const [allUsersOfSelectedOrganization, setAllUsersOfSelectedOrganition] =
    useState<UsersOfSelectedOrganization[]>([]);

  const [allGroupsOfSelectedOrganization, setAllGroupsOfSelectedOrganition] =
    useState<GroupModel[]>([]);

  const [allRolesOfSelectedOrganization, setAllRolesOfSelectedOrganition] =
    useState<RolesModel[]>([]);

  const [allRobotsOfSelectedOrganization, setAllRobotsOfSelectedOrganition] =
    useState<Robot[]>([]);

  const [defineData, setDefineData] = useState<boolean>(false);

  const [shouldShowSaveModelPopup, setShouldShowSaveModelPopup] =
    useState<boolean>(false);

  const [nameModelPopUp, setNameModelPopUp] = useState<boolean>(false);

  const orgPanelPositionRef = useRef<any>("");
  const dropZoneRef = useRef<any>(null);
  const propertPanelResizeRef = useRef<any>();
  const errorElementsRef = useRef<any[]>([]);
  const isSavingRef = useRef(false);
  const [hasValidationErrors, setHasValidationErrors] = useState<boolean>(false);

  const { processModelList } = useSelector((state: RootState) => state.process);
  const [processModelName, setProcessModelName] = useState(() => {
    const baseName = getTranslation(translations, "pm.placeholder.untitledprocessmodel");
    if (pathname.includes("insert")) {
      return generateUniqueName(
        baseName,
        processModelList.map(m => m.name || "")
      );
    }
    return baseName;
  });

  // leave it there still if it is not used we will need it later in the associations dialog
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [associations, setAssociations] = useState<AssociationResponse | null>(
    null
  );
  const getUsername = (user: {
    username?: string;
    firstname?: string;
    lastname?: string;
    email?: string;
  }) => {
    if (user.username) {
      return user.username;
    } else if (user.firstname || user.lastname) {
      return (
        user.firstname +
        (user.firstname && user.lastname ? " " : "") +
        user.lastname
      );
    } else {
      return user.email || "";
    }
  };
  // crea un modello per la realizzazione di un'applicazione mobile android
  const {
    bpmnModeler,
    selectedLane,
    extensionElementsRef,
    extensionSubprocesses,
    extensionElements,
    openDiagram,
    shouldShowDropZoneError,
    currentElementRef,
    handleCanvasViewPort,
    selectedElements,
    currentElement,
    onLaneMouseDown,
    processModelData,
    setProcessModelData,
    primaryPropertiesNameRef,
    setExtensionElementsWithRef,
    originalXml,
    isShapeRemoved,
    setIsShapeRemoved,
    isShapeAdded,
    setIsShapeAdded,
    isParticipantChanged,
    setIsParticipantChanged,
    isElementMoved,
    setIsElementMoved,
  } = useBpmnModeler({
    setUserschema: (rows: LegacySchemaRow[]) => setSchema(rowsToFields(rows)),
    setSchemaDocument: setSchema,
    // `?node=<designerid>` (link dal Diagramma SLA) preseleziona il nodo come
    // `state.designerid` delle card attivita'.
    selectedDesignerId: state?.designerid ?? searchParams.get("node") ?? undefined,
    getUsername,
    pathname,
    editId: editId ? editId : "",
    setProcessModelName,
    setModelType,
  });

  // Modifica il modello attuale in modo che prima della consegna dell'abito venga aspettato il pagamanto del cliente
  const idToUse = processModelId ?? editId;

  const doDepublish = async () => {
    if (modelType !== 1) return;
    try {
      const { data } = await processmodelsApi.delete(`${idToUse}/depublish`);
      sendSnack({
        message: data.responsemessage,
        type: "success",
      });
      setErrors([]);
      setModelType(0);
    } catch {
    } finally {
    }
  };

  // Active-processes warning: shown only when the BE reports at
  // least one active process on the model. Fails open — if the
  // endpoint is missing, the depublish proceeds immediately.
  const {
    warning: activeProcessesWarning,
    requestWarning,
    confirmWarning,
    cancelWarning,
  } = useDepublishWithWarning({
    onSkip: doDepublish,
    onConfirm: doDepublish,
  });

  const handleDepublishing = async (_shouldEnablePublish: boolean) => {
    if (modelType !== 1) return;
    if (idToUse === undefined) return;
    requestWarning(Number(idToUse));
  };

  const {
    aiAnswers,
    llmInputRef,
    handleSubmit: _handleSubmitLLM,
    openAI,
    setOpenAI,
    loading: LLMLoading,
    modelInputRef,
    stopLLM,
    sessions,
    currentSessionId,
    startNewSession,
    loadSession,
    deleteSession,
    renameSession,
    shareSession,
    currentIdSession,
    handleRetry,
    searchSessions,
    searching,
    refreshSessions,
    modelProvider,
    setModelProvider,
    modelName,
    setModelName,
  } = useLLM("model", true);
  const [isRobotPropertyDialogOpen, setIsRobotPropertyDialogOpen] = useState(false);
  const isRobotDialogOpenRef = useRef(false);
  const [pendingAutosave, setPendingAutosave] = useState(false);
  const [isSavingModel, setIsSavingModel] = useState(false);
  const isMountedRef = useRef(true);
  const [showAutosaveAlerts, setShowAutosaveAlerts] = useState(() => {
    return localStorage.getItem(CONSTANTS.STORE_AUTOSAVE_ALERTS) !== 'false';
  });
  const robotValidationRef = useRef<(() => boolean) | null>(null);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (!isSavingModel) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [isSavingModel]);

  const [isRobotSwimlane, setIsRobotSwimlane] = useState<boolean>(false);
  const [robotName, setRobotName] = useState<string | null>(null);

  useEffect(() => {
    let element = currentElement;
    if (element?.labelTarget) {
      element = element.labelTarget;
    }

    // if (element && element.type === "bpmn:Lane") {
    if (element && element.type && element.type.startsWith("bpmn:")) {
      // console.log(element.type)
      const bo = getBusinessObject(element);
      if (extensionElements) {
        const robotInSwimlane = extensionElements[bo.id]?.find(
          (participant: any) => participant.idparticipanttype === 4
        );

        if (robotInSwimlane) {
          setIsRobotSwimlane(true);
          setRobotName(robotInSwimlane.name);
        } else {
          setIsRobotSwimlane(false);
          setRobotName(null);
        }
      } else {
        setIsRobotSwimlane(false);
        setRobotName(null);
      }
    } else {
      setIsRobotSwimlane(false);
      setRobotName(null);
    }
  }, [currentElement, extensionElements]);

  const handleDismissAlert = () => {
    localStorage.setItem(CONSTANTS.STORE_AUTOSAVE_ALERTS, 'false');
    setShowAutosaveAlerts(false);
  };

  const handleToggleAlerts = () => {
    const newValue = !showAutosaveAlerts;
    localStorage.setItem(CONSTANTS.STORE_AUTOSAVE_ALERTS, newValue.toString());
    setShowAutosaveAlerts(newValue);
  };
  // console.log(processModelData, "processmodeldata")
  const swimlanes = processModelData.swimlanes || [];
  // console.log(swimlanes)

  const publishedWithProcess = modelType === 1 && processModelData.hasprocess;
  const selectedOrganization = useSelectedOrganization();
  const isAdmin = selectedOrganization?.administrator;

  // Bozza SLA del modello (processo + attivita'), resa nel pannello proprieta'
  // e salvata subito dopo ogni salvataggio riuscito del modello.
  const slaUsers = useMemo(
    () =>
      (allUsersOfSelectedOrganization ?? []).map((user) => ({
        id: user.id,
        name: getUsername(user),
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [allUsersOfSelectedOrganization],
  );
  const slaRoles = useMemo(
    () => (allRolesOfSelectedOrganization ?? []).map(({ id, name }) => ({ id, name })),
    [allRolesOfSelectedOrganization],
  );
  const slaGroups = useMemo(
    () => (allGroupsOfSelectedOrganization ?? []).map(({ id, name }) => ({ id, name })),
    [allGroupsOfSelectedOrganization],
  );
  const sla = useSlaModelDraft({
    idorganization: selectedOrganization?.id ?? null,
    idprocessmodel: idToUse ? Number(idToUse) : null,
    enabled: Boolean(isAdmin),
    users: slaUsers,
    roles: slaRoles,
    groups: slaGroups,
    participants: extensionElements ?? null,
    processName: processModelName,
    getDesignerIds: () =>
      bpmnModeler
        ? bpmnModeler
            .get("elementRegistry")
            .getAll()
            .map((element: { id: string }) => element.id)
        : null,
  });
  const handleSubmitLLM = async () => {
    const { xml } = await bpmnModeler.saveXML({
      format: true,
    });
    const participants = [
      ...allGroupsOfSelectedOrganization.map(({ id, name }) => ({
        id,
        name,
        type: 1,
      })),
      ...allRolesOfSelectedOrganization.map(({ id, name }) => ({
        id,
        name,
        type: 2,
      })),
      ...allUsersOfSelectedOrganization.map((a) => ({
        name: getUsername(a),
        id: a.id,
        type: 3,
      })),
      ...allRobotsOfSelectedOrganization.map(({ id, name }) => ({
        id,
        name,
        type: 4,
      })),
    ];
    await _handleSubmitLLM({ xml, participants });
    await refreshSubscriptionFeatures()
  };

  const resetColorsOnDiagram = useCallback(() => {
    if (bpmnModeler) {
      const modeling = bpmnModeler.get("modeling");
      // commented because it was causing problems with colors not being reset properly
      // const elements = bpmnModeler.get("elementRegistry");
      // elements.forEach((el: any) => modeling.setColor(el, null));

      //new logic
      errorElementsRef.current.forEach((el: any) => {
        modeling.setColor(el, null);
      });
      errorElementsRef.current = [];
    }
  }, [bpmnModeler]);

  const getRequestBodyForExtensionElements = useCallback(() => {
    let requestBodyForExtensionElements: Array<ExtensionElementType> = [];
    if (extensionElementsRef.current) {
      Object.keys(extensionElementsRef.current).forEach((key: string) => {
        requestBodyForExtensionElements.push(
          ...extensionElementsRef.current[key]
        );
      });
    }
    return requestBodyForExtensionElements;
  }, [extensionElementsRef]);

  const handleValidation = async (callBack?: () => void) => {
    try {
      if (bpmnModeler) {
        setErrors([]);
        const { xml: currentWorkingProcessModel } = await bpmnModeler.saveXML({
          format: true,
        });

        const { data } = await processmodelsApi.put(`/validate`, {
          entities: processModelData.entities,
          model: currentWorkingProcessModel?.replaceAll("#ff0000", "#000000"),
          extensionelements: getRequestBodyForExtensionElements(),
          extensionsubprocesses: extensionSubprocesses,
          extensionflownodes: processModelData.extensionflownodes,
          extensionswimlanes: processModelData.extensionswimlanes,
          idorganization: selectedOrganization?.id,
          name: processModelName,
          version: 0,
          modeltype: 0,
          creation: processModelData.creation,
          id: idToUse,
          swimlanes: processModelData.swimlanes,
        });
        // console.log(processModelData.swimlanes, processModelData.extensionswimlanes)
        sendSnack({
          message: data.responsemessage,
          type: "success",
        });
        // processModelsRef.current.validatedProcessModel =
        //   currentWorkingProcessModel;
        if (callBack) {
          callBack();
        }
        setErrors([]);
        setHasValidationErrors(false);
      }
    } catch (error: any) {
      if (error?.response?.data?.validation) {
        setErrors(error?.response?.data?.validation ?? []);
        setHasValidationErrors(true);
      } else {
        // console.log(processModelData.swimlanes, processModelData.extensionswimlanes)
        sendSnack({
          message: String(error),
          type: "error",
        });
      }

      return true;
    }
  };

  useEffect(() => {
    let isOverLapEnabled = localStorage.getItem(
      CONSTANTS.STORE_OVERLAP_ENABLED
    );
    if (isOverLapEnabled === "true") {
      setIsOverlapChecked(true);
    } else {
      setIsOverlapChecked(false);
    }
  }, []);

  useEffect(() => {
    return () => setSelectedError(null);
  }, []);

  // Utenti, gruppi, ruoli e robot dell'organizzazione (lane e ruolo di
  // escalation SLA). Dipende dall'id: a caricamento diretto della pagina
  // `OrganizationsContext` non ha ancora l'organizzazione al mount, e con
  // `[]` la lettura usciva subito senza ripetersi (liste vuote).
  useEffect(() => {
    callOrganizationAllUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization?.id]);

  useEffect(() => {
    if (searchParams.get("validate") && bpmnModeler) {
      setTimeout(handleValidation);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, processModelName]);

  useEffect(() => {
    if (bpmnModeler) {
      const modeling = bpmnModeler.get("modeling");
      const elements = bpmnModeler.get("elementRegistry");
      resetColorsOnDiagram();
      const newErrorElement = errors
        .filter((_: any, ind: number) => ind === selectedError)
        .map((error: any) => {
          return elements.get(error.designerid);
        })
        .filter((_: any) => _);
      if (newErrorElement && newErrorElement.length > 0) {
        for (let el of newErrorElement) {
          modeling.setColor(el, {
            stroke: "red",
          });
        }
        errorElementsRef.current = newErrorElement; //added this line to keep track of error elements
      }
    }
  }, [errors, bpmnModeler, selectedError, resetColorsOnDiagram]);

  const callOrganizationAllUsers = async () => {
    if (!selectedOrganization?.id) return;
    try {
      const promises = [
        organizationsApi.get(`${selectedOrganization?.id}/users`), //HELP
        organizationsApi.get(`${selectedOrganization?.id}/groups?page=1&pagesize=100&p=`), //TEMPORARY
        organizationsApi.get(`${selectedOrganization?.id}/roles?page=1&pagesize=100&p=`), //TEMPORARY
        organizationsApi.get(`${selectedOrganization?.id}/robots`), //I DONT UNDERSTAND HOW IT IS DONE, WHY NOT PAGED BUT STILL WORKING?!??!
      ];

      // `allSettled`: un elenco che fallisce (es. robot) non svuota gli altri.
      const [usersresult, groupsresult, rolesresult, robotsresult] =
        await Promise.allSettled(promises);
      const dataOf = (result: PromiseSettledResult<{ data?: any }>) =>
        result.status === "fulfilled" ? result.value?.data : undefined;
      setAllUsersOfSelectedOrganition(dataOf(usersresult)?.users ?? []);
      setAllGroupsOfSelectedOrganition(dataOf(groupsresult)?.groups ?? []);
      setAllRolesOfSelectedOrganition(dataOf(rolesresult)?.roles ?? []);
      setAllRobotsOfSelectedOrganition(dataOf(robotsresult)?.robots ?? []);
    } catch {
    } finally {
    }
  };

  const inputRef = useRef<HTMLInputElement>(null);
  const handleKeyDown = async (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      //cleanup (claude tip)
      if (nameChangeTimer) {
        clearTimeout(nameChangeTimer);
        setNameChangeTimer(null);
      }

      inputRef.current?.blur();

      if (bpmnModeler && processModelName !== processModelData.name) {
        const { xml } = await bpmnModeler.saveXML({ format: true });
        await saveXml(xml, null, false, false, false); // xml, callback, create_revision, showSnackbar, shouldOpenDiagram
      }
    }
  };

  // console.log(mode)

  const saveOppPosition = (orgId?: number | null, modelId?: number) => {
    let oppPosition = {
      idorganization: orgId,
      modelId: modelId,
      height: orgPanelPositionRef.current,
    };

    const listOfOppPositions = localStorage.getItem(
      CONSTANTS.STORE_OPP_POSITION
    );
    const allValidPositions = listOfOppPositions
      ? JSON.parse(listOfOppPositions)
      : [];

    let prevStoredPosIndex = allValidPositions.findIndex((pos: any) => {
      if (
        pos.idorganization === oppPosition.idorganization &&
        pos.modelId === oppPosition.modelId
      ) {
        return pos;
      }
      return false;
    });

    if (prevStoredPosIndex >= 0) {
      allValidPositions.splice(prevStoredPosIndex, 1, oppPosition);
    } else {
      allValidPositions.push(oppPosition);
    }

    localStorage.setItem(
      CONSTANTS.STORE_OPP_POSITION,
      JSON.stringify(allValidPositions)
    );
  };

  const saveXmlAs = async (xml: string) => {
    let requestBodyForExtensionElements: Array<ExtensionElementType> =
      getRequestBodyForExtensionElements();
    try {
      const uniqueName = generateUniqueName(values.saveAsName, processModelList.map(m => m.name || ""));
      const { data } = await organizationsApi.post(
        `${selectedOrganization?.id}/processmodels`,
        {
          ...newModelSchemaCommand(schema, xml.replaceAll("#ff0000", "#000000")),
          entities: [],
          model: xml.replaceAll("#ff0000", "#000000"),
          extensionelements: requestBodyForExtensionElements,
          extensionflownodes: processModelData.extensionflownodes,
          extensionswimlanes: processModelData.extensionswimlanes,
          extensionsubprocesses: extensionSubprocesses,
          idorganization: selectedOrganization?.id,
          name: uniqueName,
          version: 0,
          modeltype: 0,
          creation: processModelData.creation,
          // Un clone nasce con le **stesse** definizioni: senza questa riga il
          // modello copiato esisteva, il diagramma era identico, e i campi
          // dell'originale non c'erano piu'. Nessuno se ne accorgeva finche'
          // qualcuno non provava a compilarne uno.
          userschema: JSON.stringify(toLegacySchema(schema).rows),
        }
      );
      navigate(`/dashboard/process/edit/${data?.id}`);
      setOpenSaveAsDialog(false);
      // TROVARE SOLUZIONE MIGLIORE DEL LOCATION RELOAD
      // eslint-disable-next-line no-restricted-globals
      // location.reload();
    } catch (e: any) {
    } finally {
    }
  };
  const saveXml = async (
    xml: string,
    callBack: any,
    create_revision: boolean = false,
    showSnackbar: boolean = true,
    shouldOpenDiagram: boolean = false,
    schemaToSave: FieldDefinition[] = schema
  ) => {
    //this might be useless since we are already validating this in the RobotPropertiesDialog
    if (robotValidationRef.current && !robotValidationRef.current()) {
      sendSnack({ message: "Please fix robot properties errors before saving.", type: "error" });
      return;
    }
    // const _selectedError = selectedError;
    // resetColorsOnDiagram();
    let requestBodyForExtensionElements: Array<ExtensionElementType> =
      getRequestBodyForExtensionElements();
    if (!processModelName) {
      sendSnack({
        message: getTranslation(
          translations,
          "generic.process_name_cannot_be_empty.caption"
        ),
        type: "error",
      });
      return;
    }
    // Salvataggio esplicito con uno SLA incompleto (durata/unita' vuote): si
    // blocca anche il modello, i campi diventano rossi e lo SLA non va perso in
    // silenzio. Gli autosave salvano il modello e lasciano lo SLA in attesa.
    if (showSnackbar && !sla.validateForSave()) return;
    if (mode === "create") {
      if (isSavingRef.current) return;
      isSavingRef.current = true;
      try {
        const uniqueName = generateUniqueName(processModelName, processModelList.map(m => m.name || ""));

        const { data } = await organizationsApi.post(
          `${selectedOrganization?.id}/processmodels?create_revision=${create_revision}`,
          {
            ...newModelSchemaCommand(schemaToSave, xml.replaceAll("#ff0000", "#000000")),
            entities: [],
            model: xml.replaceAll("#ff0000", "#000000"),
            extensionelements: requestBodyForExtensionElements,
            extensionflownodes: processModelData.extensionflownodes,
            extensionswimlanes: processModelData.extensionswimlanes,
            extensionsubprocesses: extensionSubprocesses,
            idorganization: selectedOrganization?.id,
            idfolder: state?.folderId ?? null,
            name: uniqueName,
            version: 0,
            modeltype: 0,
            creation: processModelData.creation,
            userschema: JSON.stringify(toLegacySchema(schemaToSave).rows),
            id: idToUse,
          }
        );
        if (uniqueName !== processModelName) {
          setProcessModelName(uniqueName);
        }
        setProcessModelData((prev) => ({ ...prev, ...data, name: uniqueName }));
        // setEditIdValue(data?.id);

        // processModelsRef.current.editIdValue = data?.id;
        // setExistingModelNames(prev => [...prev, uniqueName]);
        saveOppPosition(selectedOrganization?.id, data.id);
        setMode("edit");
        setProcessModelId(data?.id);
        // console.log(processModelId, "dentro create")
        // if (mode !== "create") { //nel caso dell'autosave
        //   navigate(`/dashboard/process/edit/${trueEditId}`, { replace: true });
        // }
        if (showSnackbar) {
          sendSnack({
            message: data.responsemessage,
            type: "success",
          });
        }
        // processModelsRef.current.savedProcessModel = xml;
        originalXml.current = xml;
        // SLA dopo il modello: con l'id appena creato e i nodi gia' salvati.
        await sla.persist(Number(data?.id), { explicit: showSnackbar });
        if (callBack) callBack(Number(data?.id));
        setErrors([]);
      } catch (e: any) {
        if (e?.response?.data?.validation) {
          setErrors(e?.response?.data?.validation ?? []);
        }
      } finally {
        isSavingRef.current = false;
      }
    }

    else if (mode === "edit") {
      // console.log(processModelId, "dentro edit")
      if (isSavingRef.current) return;
      isSavingRef.current = true;
      try {
        if (bpmnModeler) {
          const otherModelNames = processModelList.map(m => m.name || "").filter(name => name !== processModelData.name);
          const uniqueName = generateUniqueName(processModelName, otherModelNames);
          const { data } = await processmodelsApi.put<any>(
            `${String(idToUse)}?create_revision=${create_revision}`,
            {
              entities: [],
              idorganization: selectedOrganization?.id,
              model: xml.replaceAll("#ff0000", "#000000"),
              extensionelements: requestBodyForExtensionElements,
              extensionflownodes: processModelData.extensionflownodes,
              extensionswimlanes: processModelData.extensionswimlanes,
              extensionsubprocesses: extensionSubprocesses,
              modeltype: 0,
              name: uniqueName,
              version: 0,
              userschema: JSON.stringify(toLegacySchema(schemaToSave).rows),
              creation: processModelData.creation,
              id: idToUse,
            }
          );

          if (uniqueName !== processModelName) {
            setProcessModelName(uniqueName);
          }

          setMode("edit");
          //sennò salva a nastro quando cambi nome
          setProcessModelData((prev) => ({
            ...prev,
            name: uniqueName,
          }));
          // processModelsRef.current.savedProcessModel = data.model;
          originalXml.current = data.model;
          if (shouldOpenDiagram) {
            openDiagram(data.model, true)
          };
          // bpmnModeler.importXML(data.model);
          saveOppPosition(selectedOrganization?.id, Number(editId));
          // console.log('data.success: ', data.success);
          if (data.responsemessage) {
            if (showSnackbar) {
              sendSnack({
                message: data.responsemessage,
                type: "success",
              });
            }
          }
          // SLA dopo il modello: i nodi nuovi esistono gia' sul Server.
          await sla.persist(Number(idToUse), { explicit: showSnackbar });
          if (callBack) {
            callBack(Number(idToUse));
          }
          setErrors([]);
        }
      } catch (error: any) {
        if (
          error?.response?.data?.entities &&
          error?.response?.data?.activities
        ) {
          setAssociations(error.response.data);
        }
        if (error?.response?.data?.validation) {
          setErrors(error?.response?.data?.validation ?? []);
        }
      } finally {
        // setSelectedError(_selectedError);
        isSavingRef.current = false;
      }
    }
  };

  /**
   * Salvataggio esplicito del modello (nuova revisione): pulsante della toolbar
   * e pulsante della sezione SLA del pannello proprieta' (`SlaModelSaveProvider`).
   */
  const handleSaveModel = async () => {
    if (!idToUse || isSavingModel) return;
    setIsSavingModel(true);
    try {
      const data = await bpmnModeler?.saveXML({ format: true });
      if (!data) return;
      await saveXml(
        data.xml,
        () => {
          if (!isMountedRef.current) return;
          navigate(`/dashboard/process/edit/${idToUse}`, { replace: true });
        },
        true
      );
    } finally {
      setIsSavingModel(false);
    }
  };

  const publishXml = async () => {
    try {
      if (mode === "edit") {
        // Pubblicazione con uno SLA incompleto: stesso blocco del salvataggio.
        if (!sla.validateForSave()) return;
        const { xml } = await bpmnModeler.saveXML({
          format: true,
        });
        await saveXml(xml, null, true, false, false)
        const { data } = await processmodelsApi.post(`${idToUse}/publish`);
        sendSnack({
          message: data.responsemessage,
          type: "success",
        });
        setErrors([]);
        setModelType(1);
        setHasValidationErrors(false);
      } else {
        sendSnack({
          message: getTranslation(
            translations,
            "generic.save_process_model.before_publish.caption"
          ),
          type: "success",
        });
      }
    } catch (error: any) {
      if (error?.response?.data?.validation) {
        setErrors(error?.response?.data?.validation ?? []);
        setHasValidationErrors(true);
      }
    }
  };

  /**
   * L'esportazione, con lo schema dentro il file.
   *
   * Un `.flw` senza le definizioni dei campi e' un modello che, reimportato,
   * perde quello che l'utente aveva configurato — e la perdita non si vede,
   * perche' il diagramma e' identico. Quindi lo schema **viaggia nel file**, e
   * se non si riesce a leggerlo l'esportazione non parte: un file che dichiara
   * di portare i campi e non li porta e' peggio di nessun file.
   */
  const exportModel = async (modelName: string) => {
    if (!bpmnModeler) return;

    let documento: SchemaDocument;
    try {
      if (mode === "create") {
        // Un modello non ancora salvato non ha revisioni: le definizioni sono
        // quelle in memoria, e dichiararle con revisione zero e' cio' che sono.
        documento = {
          contractVersion: 1,
          modelId: "",
          schemaRevision: 0,
          policyRevision: 0,
          fields: schema,
        };
      } else {
        documento = await customFieldsApi.getSchema(String(idToUse));
      }
    } catch (e) {
      sendSnack({
        message: getTranslation(translations, "custom_fields.export.schema_unavailable"),
        type: "error",
      });
      return;
    }

    const data = await bpmnModeler.saveXML({ format: true });
    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," +
        encodeURIComponent(embedSchema(clearLanes(data.xml || ""), documento))
    );
    element.setAttribute("download", `${modelName}.flw`);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  };

  function camelToNormal(str: string) {
    return str.replace(/([A-Z])/g, " $1").toLowerCase();
  }

  const getNameOfTheSelectedElement = () => {
    if (currentElementRef.current) {
      const bo = getBusinessObject(currentElementRef.current);
      const isTimerEvent = bo.eventDefinitions && bo.eventDefinitions.length;
      if (isTimerEvent) {
        return `Timer ${camelToNormal(bo.$type.split(":")[1])}`;
      }
      return camelToNormal(bo.$type.split(":")[1]);
    }
    return "";
  };

  const addEncoding = (xml: string) =>
    xml.replace(
      `<?xml version="1.0"?>`,
      `<?xml version="1.0" encoding="UTF-8"?>`
    );

  // const onClickGoBack = () => {
  //   // TODO: se ha modificato qualcosa far vedere il popup per dire sicuro di voler uscire?
  //   // if (saveBtnRef.current.className.includes("save-btn-enable")) {
  //   if (bpmnModeler) {
  //     const parser = new DOMParser();
  //     const serializer = new XMLSerializer();
  //     bpmnModeler.saveXML({ format: false }).then((data: any) => {
  //       const current = removeFormat(
  //         addEncoding(
  //           serializer.serializeToString(
  //             parser.parseFromString(data.xml, "text/xml")
  //           )
  //         )
  //       );
  //       const compare = removeFormat(
  //         addEncoding(
  //           serializer.serializeToString(
  //             parser.parseFromString(originalXml.current, "text/xml")
  //           )
  //         )
  //       );
  //       if (current !== compare) {
  //         setShouldShowSaveModelPopup(true);
  //       } else {
  //         navigate(-1);
  //       }
  //     });
  //   }
  // };

  const onClickValidationBtn = (callBack: () => void): void => {
    handleValidation(callBack);
  };

  // Larghezza scelta a mano dall'utente (trascinando il bordo) nella sessione:
  // le riaperture la rispettano, anche se piu' stretta del default.
  const userPanelWidthRef = useRef<number | null>(null);
  const setPropertyPanelWidth = (open: boolean) => {
    const panel = propertPanelResizeRef.current?.resizable;
    if (!panel) return;
    const width = open
      ? userPanelWidthRef.current ?? getPropertyPanelOpenWidth()
      : PROPERTY_PANEL_CLOSED_WIDTH;
    panel.style.width = `${width}px`;
  };
  const togglePropertyPanel = () => {
    setShouldShowFlowNodeEditor((_) => {
      setPropertyPanelWidth(!_);
      return !_;
    });
  };
  const closePropertyPanel = () => {
    setShouldShowFlowNodeEditor((_) => {
      setPropertyPanelWidth(false);
      return false;
    });
  };
  // Proprieta' del processo (radice): il pannello mostra l'editor di processo
  // solo a selezione vuota, quindi si svuota la selezione bpmn-js (il
  // `selection.changed` aggiorna `selectedElements`) e si apre il pannello se chiuso.
  const openProcessProperties = () => {
    bpmnModeler?.get("selection")?.select(null);
    if (!shouldShowFlowNodeEditor) {
      setPropertyPanelWidth(true);
      setShouldShowFlowNodeEditor(true);
    }
  };

  // Modifiche solo SLA (nessun cambio XML, quindi nessun autosave del modello):
  // a modello esistente si salvano da sole dopo una pausa. Con un salvataggio
  // del modello in corso ci pensa il suo `sla.persist`; in `/process/insert`
  // la bozza attende il primo salvataggio, che crea il modello.
  const { dirty: slaDirty, drafts: slaDrafts, persist: persistSla } = sla;
  useEffect(() => {
    if (!slaDirty || mode !== "edit" || !idToUse) return;
    const timer = setTimeout(() => {
      if (!isSavingRef.current) persistSla(Number(idToUse));
    }, 1200);
    return () => clearTimeout(timer);
  }, [slaDirty, slaDrafts, mode, idToUse, persistSla]);

  // `?node=` (link "Configura SLA" del Diagramma SLA): il pannello proprieta'
  // si apre una volta, sul nodo preselezionato.
  const openedForNodeRef = useRef(false);
  useEffect(() => {
    if (openedForNodeRef.current || !searchParams.get("node") || !isAdmin) return;
    if (!propertPanelResizeRef.current?.resizable) return;
    openedForNodeRef.current = true;
    setPropertyPanelWidth(true);
    setShouldShowFlowNodeEditor(true);
  },[searchParams, isAdmin, bpmnModeler]);
  /**
   * Le corsie e i task del modello, per il selettore di visibilità.
   *
   * Si leggono dal registry del modeler quando la master si apre: il modello
   * cambia mentre il designer è aperto, e un elenco calcolato una volta sola
   * mostrerebbe corsie che non esistono più — o nasconderebbe quelle appena
   * disegnate.
   *
   * Corsie e task restano separati: i loro id appartengono a insiemi diversi, e
   * un elenco unico lascerebbe scegliere una corsia dove serve un task.
   */
  const visibilityElements = useMemo(() => {
    const vuoto = { lanes: [], tasks: [] } as {
      lanes: ElementChoice[];
      tasks: ElementChoice[];
    };
    if (!defineData || !bpmnModeler) return vuoto;

    // La forma che serve dall'element registry: `parent` è ciò che lega una
    // corsia al suo pool, ed è l'unico motivo per cui non basta `getAll()`.
    type Elemento = {
      id: string;
      type: string;
      businessObject?: { name?: string };
      parent?: Elemento;
    };

    const registry = bpmnModeler.get("elementRegistry") as {
      getAll: () => Elemento[];
    };

    const tutti = registry.getAll();

    // Senza nome si mostra l'id: una voce vuota non si potrebbe scegliere.
    const nome = (element: Elemento) => element.businessObject?.name || element.id;

    /**
     * Il pool di una corsia, quando c'è.
     *
     * Le lane di un pool sono alternative — se ne sceglie una, e la dialog lo
     * impone — e il pool è ciò che le tiene insieme. Una corsia fuori da un
     * pool è già il suo gruppo: `null`.
     *
     * bpmn-js mette la lane sotto il pool: `handleParticipant` disegna il
     * processo dentro la shape del partecipante, e la laneSet del processo
     * eredita quel contesto (BpmnTreeWalker). Una sotto-lane annidata invece
     * finisce sotto la lane che la contiene, e resta un gruppo a sé.
     */
    const poolOf = (lane: Elemento): ElementChoice["group"] => {
      const parent = lane.parent;
      if (!parent || parent.type !== "bpmn:Participant") return null;
      // Un pool senza nome non si annuncia con il suo id: un'intestazione
      // "Participant_1q3u0w6" è peggio di nessuna intestazione.
      const label = parent.businessObject?.name?.trim();
      return { id: parent.id, label: label ? label : null };
    };

    const laneOf = (element: Elemento): Elemento | null => {
      let parent = element.parent;
      while (parent) {
        if (parent.type === "bpmn:Lane") return parent;
        parent = parent.parent;
      }
      return null;
    };

    const taskGroup = (task: Elemento): ElementChoice["group"] => {
      const lane = laneOf(task);
      if (!lane) return null;
      let parent = lane.parent;
      while (parent && parent.type !== "bpmn:Participant") parent = parent.parent;
      const label = [lane.businessObject?.name, parent?.businessObject?.name]
        .map((part) => part?.trim())
        .filter(Boolean)
        .join(" · ");
      return { id: lane.id, label: label || null };
    };

    return {
      lanes: tutti
        .filter((element) => element.type === "bpmn:Lane")
        .map((lane) => ({
          elementId: lane.id,
          label: nome(lane),
          group: poolOf(lane),
        })),
      tasks: [
        ...tutti
          .filter((element) => element.type.startsWith("bpmn:") && element.type.endsWith("Task"))
          .map((task) => ({ elementId: task.id, label: nome(task), group: taskGroup(task) })),
        // Lo start event è una voce dello **scope task**: rende un campo
        // visibile solo nella dialog di startprocess (CF09). Contratto per il
        // server (`policy` / `resolve_access`): `elementId` è il designerid
        // dell'evento, esattamente come per un task — nessun campo in più sul
        // filo. A distinguere un task da uno start è il server, che risolve il
        // designerid nel modello BPMN: `bpmn:StartEvent` → la voce vale solo
        // per la startprocess, `*Task` → come oggi.
        ...tutti
          .filter((element) => element.type === "bpmn:StartEvent")
          .map((event) => ({
            elementId: event.id,
            label: `Start — ${nome(event)}`,
            group: taskGroup(event),
          })),
      ],
    };
  }, [defineData, bpmnModeler]);

  /**
   * `REVISION_CONFLICT`: il modello e' cambiato sotto la bozza.
   *
   * Il contratto lo dice con `error.code`; la rotta legacy del modello puo'
   * rispondere col solo 409. Sono lo stesso fatto.
   */
  const isRevisionConflict = (error: unknown) =>
    (error as { response?: { status?: number } })?.response?.status === 409 ||
    apiError(error)?.code === "REVISION_CONFLICT";

  /**
   * Il modello e' cambiato durante il salvataggio.
   *
   * Niente retry silenzioso: si rilegge lo schema — la revisione nuova sara'
   * quella del prossimo `getSchema` — si chiude l'impatto pendente, che non
   * descrive piu' il modello, e lo si dice. La bozza resta all'utente.
   */
  const notifyRevisionConflict = async () => {
    setImpatto(null);
    setPendingSchema(null);
    try {
      const corrente = await customFieldsApi.getSchema(String(idToUse));
      setSchema(corrente.fields);
    } catch {
      // Se anche la lettura fallisce resta il messaggio: il prossimo
      // `getSchema` fara' comunque il suo lavoro.
    }
    const chiave = "custom_fields.error.revision_conflict";
    const risolta = getTranslation(translations, chiave);
    sendSnack({
      message:
        risolta === chiave
          ? translations["custom_fields.error.generic"] ||
            translations["generic.error.caption"] ||
            "Unable to confirm that the fields were saved. Please try again."
          : risolta,
      type: "error",
    });
  };

  const notifySchemaError = (error: unknown) => {
    const api = apiError(error);
    // Una configurazione mancante ha già la sua riga rossa e il messaggio sotto
    // il campo nella master: la snackbar direbbe la stessa cosa in un altro
    // posto, sopra un dialog che sta già indicando dove correggere.
    if (api?.fieldErrors?.length) return;
    const messageKey = messageKeyFor(api);
    sendSnack({
      message: translations[messageKey] || translations["custom_fields.error.generic"] ||
        translations["generic.error.caption"] || "Unable to confirm that the fields were saved. Please try again.",
      type: "error",
    });
  };

  const onSaveSchema = async (rows: FieldDefinition[]) => {
    if (mode === "create") {
      // Un modello che non esiste non ha revisioni ne' campi da confrontare:
      // lo schema si memorizza con il modello, e l'impatto si analizza dopo.
      setSchema(rows);
      setDefineData(false);
      return;
    }

    // Un salvataggio alla volta: vedi `salvataggioInCorso`.
    if (salvataggioInCorso.current) return;
    salvataggioInCorso.current = true;

    // Lo schema va **nel protocollo** prima del salvataggio del modello: e' il
    // protocollo a dire se la modifica e' ammissibile e cosa rompe. Scrivere
    // `userschema` e basta significherebbe applicare una modifica che nessuno
    // ha analizzato.
    setImpattoLoading(true);
    try {
      const corrente = await customFieldsApi.getSchema(String(idToUse));
      const documento: SchemaDocument = { ...corrente, fields: rows };
      // Un `operationId` per **intento**, e l'intento e' uno solo: l'analisi e
      // il salvataggio che la segue sono la stessa richiesta vista in due
      // momenti. Due id diversi farebbero del salvataggio un secondo intento.
      const operationId = create_UUID();

      const analisi = await customFieldsApi.analyzeSchema(String(idToUse), {
        operationId,
        // Le revisioni su cui la bozza e' costruita: dichiararle sbagliate
        // produce un conflitto che l'utente leggerebbe come un guasto.
        expectedRevision: {
          schema: corrente.schemaRevision,
          policy: corrente.policyRevision,
        },
        schema: documento,
        reconciliation: "next_save_or_transition",
      });

      const pending = { rows, operationId, documento };

      // Se è cambiato **solo** `inCard` (preferenza di presentazione, non forma
      // dello schema) non c'è niente da far decidere all'utente: si salva
      // direttamente. L'analisi resta comunque necessaria per l'impactToken.
      const soloInCard = isInCardOnlyChange(rows, corrente.fields);

      // Gli avvisi informativi non richiedono una decisione dell'utente.
      // L'analisi resta necessaria per ottenere l'impactToken.
      if (
        soloInCard ||
        analisi.anomalies.every((anomaly) => !anomaly.blocking && !anomaly.requiresConfirmation)
      ) {
        await applicaSchema(pending, {
          impactToken: analisi.impactToken,
          confirmationToken: analisi.confirmationToken ?? undefined,
        });
        return;
      }

      setPendingSchema(pending);
      setImpatto(analisi);
      return;
    } catch (e) {
      // Gia' mostrato e ripulito: un secondo messaggio generico sarebbe rumore.
      if (isRevisionConflict(e)) {
        await notifyRevisionConflict();
        return;
      }
      // **Nessun ripiego.** Se il servizio non risponde, lo schema non si
      // salva: un fallback scriverebbe senza autorizzazione, che e' l'unica
      // cosa che il protocollo esiste per impedire.
      notifySchemaError(e);
      throw e;
    } finally {
      salvataggioInCorso.current = false;
      setImpattoLoading(false);
    }
  };

  /**
   * Il salvataggio vero, dopo che l'impatto e' stato visto.
   *
   * `saveSchema` risponde **202**: significa che l'intento e' validato, non che
   * lo schema e' memorizzato. Il motore completa la scrittura con il
   * salvataggio del modello, ed e' per questo che si prosegue.
   */
  const applicaSchemaConfermato = async (tokens: {
    impactToken?: string;
    confirmationToken?: string;
  }) => {
    if (!pendingSchema || salvataggioInCorso.current) return;
    salvataggioInCorso.current = true;
    // `impattoLoading` spegne il confirm mentre la scrittura e' in volo.
    setImpattoLoading(true);
    try {
      await applicaSchema(pendingSchema, tokens);
    } catch (e) {
      notifySchemaError(e);
    } finally {
      salvataggioInCorso.current = false;
      setImpattoLoading(false);
    }
  };

  const applicaSchema = async (
    pending: {
      rows: FieldDefinition[];
      operationId: string;
      documento: SchemaDocument;
    },
    tokens: { impactToken?: string; confirmationToken?: string }
  ) => {
    const { rows, operationId, documento } = pending;
    const schemaChange = {
      schema: documento,
      reconciliation: "next_save_or_transition" as const,
      impactToken: tokens.impactToken,
      confirmationToken: tokens.confirmationToken,
    };
    try {
      await customFieldsApi.saveSchema(String(idToUse), {
        operationId,
        expectedRevision: {
          schema: documento.schemaRevision,
          policy: documento.policyRevision,
        },
        ...schemaChange,
      });
      await salvaModello(rows, operationId, documento, schemaChange);
      // The engine consumes the staged operation synchronously during PUT.
      // A successful legacy response alone cannot confirm canonical persistence.
      const { status } = await customFieldsApi.getOperation(operationId);
      if (status !== "applied") {
        throw new Error("Custom field schema persistence was not confirmed");
      }
    } catch (e: any) {
      // Il modello e' cambiato sotto il salvataggio: la revisione attesa non
      // vale piu'. Il conflitto si mostra e si ripulisce, non si ritenta da
      // soli — la prossima `getSchema` prendera' la revisione nuova.
      if (isRevisionConflict(e)) {
        await notifyRevisionConflict();
        return;
      }
      // Il salvataggio del modello e' il passo che **scrive** lo schema: se il
      // motore lo rifiuta — una corsia senza partecipanti, per esempio — lo
      // schema non e' salvato. Inghiottirlo qui lascia l'utente convinto di
      // aver salvato, e i campi spariscono al primo ricaricamento: il motore
      // dice cosa manca, e quella frase va mostrata.
      if (e?.response?.data?.validation) {
        setErrors(e.response.data.validation ?? []);
      }
      throw e;
    }
    setSchema(rows);
    setDefineData(false);
    setImpatto(null);
    setPendingSchema(null);
  };

  const salvaModello = async (
    rows: FieldDefinition[],
    operationId: string,
    documento: SchemaDocument,
    schemaChange: {
      schema: SchemaDocument;
      reconciliation: "next_save_or_transition";
      impactToken?: string;
      confirmationToken?: string;
    }
  ) => {
      let requestBodyForExtensionElements: Array<ExtensionElementType> =
        getRequestBodyForExtensionElements();
      const { xml } = await bpmnModeler?.saveXML({ format: true });
      await processmodelsApi.put(String(idToUse), {
        operationId,
        expectedRevision: {
          schema: documento.schemaRevision,
          policy: documento.policyRevision,
        },
        schemaChange,
        userschema: JSON.stringify(toLegacySchema(rows).rows),
        entities: [],
        idorganization: selectedOrganization?.id,
        model: xml.replaceAll("#ff0000", "#000000"),
        extensionelements: requestBodyForExtensionElements,
        extensionflownodes: processModelData.extensionflownodes,
        extensionswimlanes: processModelData.extensionswimlanes,
        extensionsubprocesses: extensionSubprocesses,
        modeltype: 0,
        name: processModelName,
        version: 0,
        creation: processModelData.creation,
        id: processModelData.id,
        // `REVISION_CONFLICT` e' una risposta prevista: la mostra il chiamante
        // con la voce di catalogo, non l'interceptor col messaggio grezzo.
      }, { params: { raise: false } });
  };

  const handleApplyAi = async (model: string) => {
    /**
     * Un modello generato puo' portare anche le definizioni dei campi.
     *
     * Il testo dell'AI e' XML come un `.flw`: se e' passato da un'esportazione,
     * dentro c'e' l'elemento dello schema, e applicarlo senza leggerlo
     * significherebbe cancellare le definizioni al primo salvataggio — con il
     * diagramma identico e nessuno che se ne accorge. Se invece l'elemento c'e'
     * e non si legge, non si applica niente: sarebbe la stessa perdita, solo
     * annunciata.
     */
    const definizioni = readSchema(model);
    if (definizioni.kind === "invalid") {
      sendSnack({
        message: getTranslation(
          translations,
          `custom_fields.import.invalid.${definizioni.reason}`
        ),
        type: "error",
      });
      return;
    }

    await bpmnModeler.importXML(model);
    const result = await processmodelsApi.post<{
      extensionswimlanes: any[];
      extensionsubprocesses: any[];
      extensionflownodes: any[];
      extensionelements: ExtensionElementType[];
    }>("extensions", { model });
    const extensionElements: ExtensionElements = {};
    for (const elem of result.data.extensionelements) {
      if (elem.linkedto in extensionElements) {
        extensionElements[elem.linkedto].push(elem);
      } else {
        extensionElements[elem.linkedto] = [elem];
      }
    }

    setExtensionElementsWithRef(extensionElements);
    setProcessModelData((prev) => ({ ...prev, ...result.data }));

    // Le definizioni che il modello porta diventano quelle del modello.
    //
    // Su un modello che esiste gia' passano dal **protocollo** — analisi e
    // impatto prima della scrittura — perche' una definizione che cambia
    // riguarda i processi gia' avviati. Su uno in creazione si memorizzano con
    // il modello, come fa la master: non c'e' ancora nessuna istanza da
    // confrontare.
    if (definizioni.kind === "ok") {
      if (mode === "edit") {
        await onSaveSchema(definizioni.document.fields);
      } else {
        setSchema(definizioni.document.fields);
      }
    }

    if (bpmnModeler && modelType !== 1 && !hasValidationErrors) {
      const allModelNames = processModelList.map(m => m.name || "");
      const uniqueName = mode === 'create'
        ? generateUniqueName(processModelName, allModelNames)
        : generateUniqueName(processModelName, allModelNames.filter(name => name !== processModelData.name));
      if (uniqueName !== processModelName) {
        setProcessModelName(uniqueName);
      }
      const { xml } = await bpmnModeler.saveXML({ format: false });
      // State updates above are asynchronous: pass the imported definitions
      // directly so creation cannot persist the schema from the previous render.
      const importedSchema = definizioni.kind === "ok" ? definizioni.document.fields : schema;
      await saveXml(xml, null, true, false, false, importedSchema);
    }
  };

  // Handoff from the AI Assistant: BpmnArtifactCard navigates here with the
  // diagram the `model` specialist produced in chat, carried in
  // location.state. Import it once, through the same path the in-canvas AI
  // uses (handleApplyAi rebuilds the extension elements too), then clear the
  // state so a re-render or a back/forward navigation doesn't re-import it
  // over the user's edits.
  const appliedAssistantXmlRef = useRef(false);
  useEffect(() => {
    const incomingXml = (state as { bpmnXml?: string } | null)?.bpmnXml;
    if (!incomingXml || !bpmnModeler || appliedAssistantXmlRef.current) return;
    appliedAssistantXmlRef.current = true;
    (async () => {
      try {
        await handleApplyAi(incomingXml);
      } catch (e) {
        console.error("Error importing the diagram from the AI Assistant", e);
        sendSnack({
          message: getTranslation(translations, "ai.returned.error"),
          type: "error",
        });
      } finally {
        navigate(pathname, { replace: true, state: null });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, bpmnModeler]);

  // Handoff from the AI Assistant, the other direction: the router decided a
  // modelling request belongs here rather than in a chat page with no canvas,
  // so it navigated with the user's question. Open the drawer, put the
  // question in it and send it -- the user asked once, they shouldn't have to
  // ask again.
  //
  // We wait for the participant lists as well as the modeller: handleSubmitLLM
  // ships groups/roles/users/robots to the skill, and firing before they land
  // would hand the model an empty organisation and produce a diagram with no
  // real lanes. The user list is never empty (it always contains the caller),
  // so it is a reliable "org data has arrived" signal.
  const submittedAssistantPromptRef = useRef(false);
  useEffect(() => {
    const incomingPrompt = (state as { aiPrompt?: string } | null)?.aiPrompt;
    if (!incomingPrompt || submittedAssistantPromptRef.current) return;
    if (!bpmnModeler || allUsersOfSelectedOrganization.length === 0) return;
    submittedAssistantPromptRef.current = true;
    setOpenAI(true);
    if (llmInputRef.current) llmInputRef.current.value = incomingPrompt;
    (async () => {
      try {
        await handleSubmitLLM();
      } catch (e) {
        console.error("Error forwarding the AI Assistant prompt", e);
      } finally {
        navigate(pathname, { replace: true, state: null });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, bpmnModeler, allUsersOfSelectedOrganization]);

  ///////// Debounce per il salvataggio del nome del modello/////////////
  const [nameChangeTimer, setNameChangeTimer] = useState<NodeJS.Timeout | null>(null);
  const [userHasModifiedName, setUserHasModifiedName] = useState(false);

  // useEffect(() => {
  //   if (nameChangeTimer) {
  //     clearTimeout(nameChangeTimer);
  //   }

  //   if (processModelName === processModelData.name || !userHasModifiedName) {
  //     return;
  //   }

  //   const newTimer = setTimeout(async () => {
  //     if (bpmnModeler && processModelName !== processModelData.name) {
  //       try {
  //         const { xml } = await bpmnModeler.saveXML({ format: true });
  //         await saveXml(xml, null, false, false); // create_revision = false, showSnackbar = false
  //       } catch {
  //       }
  //     }
  //   }, 1000);

  //   setNameChangeTimer(newTimer);
  //   //cleanup (claude tip)
  //   return () => {
  //     if (newTimer) {
  //       clearTimeout(newTimer);
  //     }
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [processModelName, processModelData.name, bpmnModeler]);

  //cleanup (claude tip)
  // useEffect(() => {
  //   return () => {
  //     if (nameChangeTimer) {
  //       clearTimeout(nameChangeTimer);
  //     }
  //   };
  // }, [nameChangeTimer]);
  /////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    isRobotDialogOpenRef.current = isRobotPropertyDialogOpen;
  }, [isRobotPropertyDialogOpen]);

  const autosave = () => {
    if (isRobotDialogOpenRef.current) {
      return;
    }

    const hasNameChange = editId && processModelName !== processModelData.name && userHasModifiedName;
    //nel caso aggiungere hasValidationErrors
    if ((modelType === 1) && !hasNameChange)
      return

    //clean name timer
    if (nameChangeTimer) {
      clearTimeout(nameChangeTimer);
      setNameChangeTimer(null);
    }

    const shouldCheckXmlChanges = !isEditing;

    if (!hasNameChange && !shouldCheckXmlChanges) {
      return;
    }

    const delay = hasNameChange ? 1000 : 0; // debounce per name change, immediato per autosave (claude tip)

    const newTimer = setTimeout(async () => {
      if (bpmnModeler) {
        const parser = new DOMParser();
        const serializer = new XMLSerializer();

        try {
          const { xml } = await bpmnModeler.saveXML({ format: false });

          const current = removeFormat(
            addEncoding(
              serializer.serializeToString(
                parser.parseFromString(xml, "text/xml")
              )
            )
          );
          const compare = removeFormat(
            addEncoding(
              serializer.serializeToString(
                parser.parseFromString(originalXml.current, "text/xml")
              )
            )
          );

          const nameChanged = editId && processModelName !== processModelData.name;
          const xmlChanged = current !== compare;

          if (xmlChanged || nameChanged) {
            setPendingAutosave(true);

            //revision solo se ci sono modifiche XML
            const shouldCreateRevision = xmlChanged;

            await saveXml(xml, null, shouldCreateRevision, false, false);
            setPendingAutosave(false);
          }
        } catch {
          setPendingAutosave(false);
        }
      }
    }, delay);

    setNameChangeTimer(newTimer);

    return () => {
      if (newTimer) {
        clearTimeout(newTimer);
      }
    };
  }
  useIdle(1000, autosave);

  useEffect(() => {
    if (isShapeRemoved) {
      autosave();
      setIsShapeRemoved(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShapeRemoved]);

  useEffect(() => {
    if (isShapeAdded) {
      autosave();
      setIsShapeAdded(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShapeAdded]);

  useEffect(() => {
    if (isParticipantChanged) {
      autosave();
      setIsParticipantChanged(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isParticipantChanged]);

  useEffect(() => {
    if (isElementMoved) {
      autosave();
      setIsElementMoved(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isElementMoved]);

  useEffect(() => {
    if (isRobotDialogOpenRef.current) {
      return;
    }
    const hasNameChange = editId && processModelName !== processModelData.name && userHasModifiedName;

    if ((modelType === 1 || hasValidationErrors) && !hasNameChange)
      return

    //clean name timer
    if (nameChangeTimer) {
      clearTimeout(nameChangeTimer);
      setNameChangeTimer(null);
    }

    const shouldCheckXmlChanges = !isEditing;

    if (!hasNameChange && !shouldCheckXmlChanges) {
      return;
    }

    const delay = hasNameChange ? 1000 : 0; // debounce per name change, immediato per autosave (claude tip)

    const newTimer = setTimeout(async () => {
      if (bpmnModeler) {
        const parser = new DOMParser();
        const serializer = new XMLSerializer();

        try {
          const { xml } = await bpmnModeler.saveXML({ format: false });

          const current = removeFormat(
            addEncoding(
              serializer.serializeToString(
                parser.parseFromString(xml, "text/xml")
              )
            )
          );
          const compare = removeFormat(
            addEncoding(
              serializer.serializeToString(
                parser.parseFromString(originalXml.current, "text/xml")
              )
            )
          );

          const nameChanged = editId && processModelName !== processModelData.name;
          const xmlChanged = current !== compare;

          if (xmlChanged || nameChanged) {
            setPendingAutosave(true);

            //revision solo se ci sono modifiche XML
            const shouldCreateRevision = xmlChanged;

            await saveXml(xml, null, shouldCreateRevision, false, false);
            setPendingAutosave(false);
          }
        } catch {
          setPendingAutosave(false);
        }
      }
    }, delay);

    setNameChangeTimer(newTimer);

    return () => {
      if (newTimer) {
        clearTimeout(newTimer);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isEditing,
    processModelName,
    processModelData.name,
    hasValidationErrors,
    userHasModifiedName,
    editId,
    bpmnModeler
  ]);

  return (
    <React.Fragment>
      <AiDrawer
        modelInputRef={modelInputRef}
        variant="persistent"
        LLMLoading={LLMLoading}
        aiAnswers={aiAnswers}
        handleSubmitLLM={handleSubmitLLM}
        llmInputRef={llmInputRef}
        openAI={openAI}
        setOpenAI={setOpenAI}
        handleApplyAi={handleApplyAi}
        canUseAi={aiRequestCanUse || bypassSubscription}
        stopLLM={stopLLM}
        sessions={sessions}
        currentSessionId={currentSessionId}
        startNewSession={startNewSession}
        loadSession={loadSession}
        deleteSession={deleteSession}
        renameSession={renameSession}
        shareSession={shareSession}
        currentIdSession={currentIdSession}
        handleRetry={handleRetry}
        searchSessions={searchSessions}
        searching={searching}
        modelProvider={modelProvider}
        setModelProvider={setModelProvider}
        modelName={modelName}
        setModelName={setModelName}
        refreshSessions={refreshSessions}
      />
      <AiFab openAI={openAI} setOpenAI={setOpenAI} />
      <Box height="100%" display="flex" flexDirection="column">
        <Stack flexWrap="wrap" direction="row" spacing={2} alignItems="center">
          {/* <Button
            variant="outlined"
            size="small"
            startIcon={<ChevronLeft />}
            id="back-button"
            onClick={onClickGoBack}
          >
            {getTranslation(translations, "pm.label.button.goback")}
          </Button> */}
          {pendingAutosave ? (
            <CircularProgress size={20} />
          ) : (
            <Save color="primary" fontSize="small" />
          )}
          <TextField
            inputRef={inputRef}
            onKeyDown={handleKeyDown}
            disabled={!isAdmin}
            className="dashed"
            id="process-name"
            type="text"
            variant="outlined"
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "20px",
              },
            }}
            value={processModelName}
            onChange={({ target }) => {
              setProcessModelName(target.value);
              setUserHasModifiedName(true); //sennò al mount da 500
            }} label={getTranslation(translations, "pm.label.process_name")}
          />
          {isAdmin && (
            <Stack direction="row" alignItems="center" spacing={2}>
              <Stack
                sx={{
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark"
                      ? theme.palette.grey[900]
                      : theme.palette.grey[100],
                  p: 0.4,
                }}
                component={Paper}
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="center"
                id={"edit-page-actions-container"}
              >
                <Tooltip
                  title={getTranslation(translations, "pm.buttons.action.save.revision")}
                >
                  <span>
                    <IconButton
                      // size="small"
                      onClick={async () => {
                        if (mode !== "create" && !idToUse) {
                          return
                        }
                        bpmnModeler
                          ?.saveXML({ format: true })
                          .then((data: any) => {
                            saveXml(data.xml, (id: number) => {
                              navigate(`/dashboard/process/edit/${id}`, {
                                replace: true,
                              });
                              if (mode === "create") {
                                // TROVARE SOLUZIONE MIGLIORE DEL LOCATION RELOAD
                                // eslint-disable-next-line no-restricted-globals
                                // location.reload();
                              }
                            }, true);
                          });
                      }}
                      id="save-process-model-btn"
                      disabled={isSavingModel}
                    >
                      {isSavingModel ? <CircularProgress size={20} /> : <SaveOutlined color="primary" />}
                    </IconButton>
                  </span>
                </Tooltip>
                {/* DUPLICATE BUTTON */}
                {mode === "edit" && (
                  <Tooltip
                    title={getTranslation(translations, "pm.button.save_as")}
                  >
                    <span>
                      <IconButton
                        // size="small"
                        id="saveas-process-model-btn"
                        onClick={() => {
                          if (!idToUse) {
                            return
                          }
                          setOpenSaveAsDialog(true)
                        }}
                      >
                        <SaveAsOutlined color="primary" />
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
                {/* DUPLICATE BUTTON */}

                <Tooltip
                  title={getTranslation(
                    translations,
                    "pm.buttons.action.validate"
                  )}
                >
                  <span>
                    <IconButton
                      // size="small"
                      id="valie-process-model-btn"
                      onClick={() => onClickValidationBtn(() => { })}
                    >
                      <VerifiedOutlined color="primary" />
                    </IconButton>
                  </span>
                </Tooltip>

                <Tooltip
                  title={getTranslation(
                    translations,
                    "pm.buttons.action.publish"
                  )}
                >
                  <span>
                    <IconButton
                      id="publish-btn"
                      disabled={
                        published || publishedWithProcess || mode === "create"
                      }
                      // size="small"
                      onClick={async () => {
                        onClickValidationBtn(publishXml);
                      }}
                    >
                      <CloudUploadOutlined
                        color={published ? "disabled" : "primary"}
                      />
                    </IconButton>
                  </span>
                </Tooltip>
                {!modelType ? (
                  <IconButton
                    // size="small"
                    disabled
                  >
                    <CloudDoneOutlined
                      color={published ? "primary" : "disabled"}
                    />
                  </IconButton>
                ) : (
                  <Tooltip
                    title={getTranslation(
                      translations,
                      "pm.buttons.action.depublish"
                    )}
                  >
                    <span>
                      <IconButton
                        id="depublish-btn"
                        // size="small"
                        onClick={() => handleDepublishing(true)}
                        disabled={activeProcessesWarning.checking}
                      >
                        {activeProcessesWarning.checking ? (
                          <CircularProgress size={20} />
                        ) : (
                          <CloudDownloadOutlined color="primary" />
                        )}
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
                {isAdmin && (
                  <React.Fragment>
                    <Divider orientation="vertical" />
                    <Tooltip
                      title={getTranslation(
                        translations,
                        "pm.button.export_model"
                      )}
                    >
                      <span>
                        <IconButton
                          id={`export-model-btn`}
                          // size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            setNameModelPopUp(true);
                          }}
                        >
                          <ImportExport color="primary" />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip
                      title={getTranslation(
                        translations,
                        "process_model.schema.title"
                      )}
                    >
                      <span>
                        <IconButton
                          id={`define-schema-process-model`}
                          // size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            setDefineData(true);
                          }}
                        >
                          <DatasetLinkedOutlined color="primary" />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </React.Fragment>
                )}

                {checkLoading ? (
                  <CircularProgress size={20} />
                ) : null}
                {/* AI assistant is opened from the floating action button
                    in the bottom-right corner (see <AiFab />). The
                    subscription-gating previously enforced here has been
                    dropped intentionally: the FAB replaces the old header
                    icon consistently across pages. */}
                <Tooltip title={showAutosaveAlerts ? `${getTranslation(translations, "generic.hide.info.alerts")}` : `${getTranslation(translations, "generic.show.info.alerts")}`}>
                  <span>
                    <IconButton
                      onClick={handleToggleAlerts}
                      color="primary"
                    >
                      {!showAutosaveAlerts ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </span>
                </Tooltip>
                {isAdmin && (
                  <Tooltip title={getTranslation(translations, "pm.propertyeditor.process.open")}>
                    <span>
                      <IconButton
                        id="process-properties-btn"
                        aria-label={getTranslation(translations, "pm.propertyeditor.process.open")}
                        onClick={openProcessProperties}
                        color="primary"
                      >
                        <Settings />
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
              </Stack>
              {checkLoading ? (
                <CircularProgress size={20} />
              ) : (
                !aiRequestCanUse && !bypassSubscription && (
                  <>
                    <Alert
                      id="ai-request-limit-alert"
                      icon={<ErrorOutline fontSize="small" />}
                      sx={{
                        minHeight: 40,
                        alignItems: "center",
                        overflowY: "hidden",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark"
                            ? "rgba(255, 183, 77, 0.10)"
                            : theme.palette.error.light,
                        color: (theme) =>
                          theme.palette.mode === "dark"
                            ? theme.palette.warning.light
                            : theme.palette.error.contrastText,
                        border: "1px solid",
                        borderColor: (theme) =>
                          theme.palette.mode === "dark"
                            ? "rgba(255, 183, 77, 0.42)"
                            : theme.palette.error.main,
                        borderLeftWidth: 4,
                        borderLeftColor: (theme) =>
                          theme.palette.mode === "dark"
                            ? theme.palette.warning.main
                            : theme.palette.error.dark,
                        fontWeight: 600,
                        letterSpacing: 0.2,
                        "& .MuiAlert-icon": {
                          color: "inherit",
                        },
                        "& .MuiAlert-message": {
                          padding: "4px 0",
                        },
                      }}
                      severity="error"
                    >
                      {getTranslation(translations, "ai_request.limit.reached")}
                    </Alert>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      sx={(theme) => ({
                        ...(theme.palette.mode === "dark" && {
                          bgcolor: "primary.main",
                          color: "primary.contrastText",
                          "&:hover": {
                            bgcolor: "primary.dark",
                          },
                        }),
                      })}
                      onClick={() =>
                        navigate(`/dashboard/organizations/${organization?.id}/billing`, {
                          state: { organizationName: organization?.name },
                        })
                      }
                    >
                      {getTranslation(translations, "generic.upgrade")}
                    </Button>
                  </>
                )
              )}

            </Stack>
          )}
        </Stack>
        {modelType === 1 && showAutosaveAlerts && isAdmin && (
          <Alert
            severity="info"
            sx={{
              alignItems: "center",
              my: 1,
              width: "fit-content",
              fontSize: 10
            }}
            action={
              <Tooltip title={getTranslation(translations, "generic.do_not_show_again.caption")}>
                <span>
                  <IconButton
                    size="small"
                    onClick={handleDismissAlert}
                  >
                    <Close fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            }
          >
            {getTranslation(translations, "alert.info.autosave.disabled")}
          </Alert>
        )}

        <Box sx={{ position: "relative" }} className="pm-dropzone-wrapper">
          {!isAdmin && (
            <Box
              sx={{
                position: "absolute",
                zIndex: 999,
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                backgroundColor: "transparent",
              }}
            />
          )}
          <Stack direction="column" width="100%" position="relative">
            <DropZoneElement
              shouldShowDropZoneError={shouldShowDropZoneError}
              onClickEditorCollapse={togglePropertyPanel}
              shouldShowFlowNodeEditor={shouldShowFlowNodeEditor}
              bpmnModeler={bpmnModeler as any}
              dropZoneRef={dropZoneRef}
            />
            {isAdmin && (
              <Box
                sx={{
                  position: isOverlapChecked ? "unset" : "relative",
                  pt: "40px",
                }}
              >
                <ProcessModelError
                  errors={errors}
                  isOverlapChecked={isOverlapChecked}
                  setSelectedError={setSelectedError}
                  selectedError={selectedError}
                />
                <OrganizationPanel
                  extensionElements={extensionElements}
                  handleCanvasViewPort={handleCanvasViewPort}
                  orgPanelPositionRef={orgPanelPositionRef}
                  allRolesOfSelectedOrganization={
                    allRolesOfSelectedOrganization
                  }
                  allGroupsOfSelectedOrganization={
                    allGroupsOfSelectedOrganization
                  }
                  allUsersOfSelectedOrganization={
                    allUsersOfSelectedOrganization
                  }
                  allRobotsOfSelectedOrganization={
                    allRobotsOfSelectedOrganization
                  }
                  getUsername={getUsername}
                  onLaneMouseDown={onLaneMouseDown}
                  selectedLane={selectedLane}
                  isOverlapChecked={isOverlapChecked}
                  setIsOverlapChecked={setIsOverlapChecked}
                />
              </Box>
            )}
          </Stack>
          {isAdmin && (
            <Resizable
              ref={propertPanelResizeRef}
              enable={{
                top: false,
                right: false,
                bottom: false,
                left: shouldShowFlowNodeEditor,
                topRight: false,
                bottomRight: false,
                bottomLeft: false,
                topLeft: false,
              }}
              style={{ marginLeft: 4 }}
              minWidth={80}
              onResizeStop={(...rest) => {
                const width = Number(rest[2].style.width.replace("px", ""));
                if (width < 95) {
                  closePropertyPanel();
                } else {
                  userPanelWidthRef.current = width;
                }
              }}
            >
              <Stack
                component={Paper}
                py={2}
                borderRadius={0}
                sx={{ clipPath: "inset(-100px 0px 0px -100px)" }}
                height="100%"
                spacing={1}
                direction="column"
              >
                <Stack
                  direction="row"
                  spacing={2}
                  px={2}
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Fab
                    size="small"
                    color="primary"
                    onClick={togglePropertyPanel}
                  >
                    <Settings id="property-panel-btn" />
                  </Fab>
                  {shouldShowFlowNodeEditor && selectedElements?.length > 0 && (
                    <Typography
                      textTransform="capitalize"
                      fontWeight="bold"
                      color="primary"
                    >
                      {isRobotSwimlane ? robotName : getNameOfTheSelectedElement()}
                    </Typography>
                  )}
                </Stack>
                {shouldShowFlowNodeEditor && (
                  <Box px={2} height={"100%"} sx={{ overflowY: "auto" }}>
                    <SlaModelDraftProvider value={sla}>
                      <SlaModelSaveProvider value={handleSaveModel}>
                      <PropertiesView
                        modeler={bpmnModeler as any}
                        selectedElements={selectedElements}
                        currentElement={currentElement}
                        extensionElements={extensionElements}
                        processModelData={processModelData}
                        getRequestBodyForExtensionElements={
                          getRequestBodyForExtensionElements
                        }
                        setProcessModelData={setProcessModelData}
                        openDiagram={openDiagram}
                        primaryPropertiesNameRef={primaryPropertiesNameRef}
                        onTriggerAutosave={async () => {
                          if (bpmnModeler) {
                            const { xml } = await bpmnModeler.saveXML({ format: true });
                            await saveXml(xml, null, true, false, false);
                          }
                        }}
                        schema={schema}
                        idToUse={idToUse}
                        robotDialogOpen={setIsRobotPropertyDialogOpen}
                        robotValidationRef={robotValidationRef}
                        processModelName={processModelName}
                      />
                      </SlaModelSaveProvider>
                    </SlaModelDraftProvider>
                  </Box>
                )}
              </Stack>
            </Resizable>
          )}
        </Box>

        <SaveProcessModelPopUp
          shouldShowSaveModelPopup={shouldShowSaveModelPopup}
          setShouldShowSaveModelPopup={setShouldShowSaveModelPopup}
          saveXml={async (callBack) => {
            if (!bpmnModeler) return;
            setIsSavingModel(true);
            try {
              const data = await bpmnModeler.saveXML({ format: true });
              await saveXml(data.xml, callBack);
            } finally {
              setIsSavingModel(false);
            }
          }}
          processModelName={processModelName}
        />
        <Dialog
          open={isSavingModel}
          disableEscapeKeyDown
          onClose={() => {}}
          maxWidth="xs"
          fullWidth
        >
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              py: 4,
            }}
          >
            <CircularProgress />
            <Typography>{getTranslation(translations, "generic.loading")}</Typography>
          </DialogContent>
        </Dialog>
        <Dialog
          open={activeProcessesWarning.open}
          onClose={cancelWarning}
        >
          <DialogTitle>
            {getTranslation(translations, "pm.depublish.activeProcesses.title")}
          </DialogTitle>
          <DialogContent>
            {activeProcessesWarning.loading ? (
              <Box display="flex" justifyContent="center" py={2}>
                <CircularProgress size={28} />
              </Box>
            ) : (
              <>
                <DialogContentText sx={{ mb: 2 }}>
                  {getTranslation(
                    translations,
                    "pm.depublish.activeProcesses.body"
                  )}
                  {" "}
                  <Box component="span" sx={{ fontWeight: 600 }}>
                    ({activeProcessesWarning.count})
                  </Box>
                </DialogContentText>
                <TableContainer
                  id="depublish-active-processes-table"
                  component={Paper}
                  variant="outlined"
                  sx={{
                    maxHeight: 240,
                    overflowY: "auto",
                    borderRadius: 1,
                  }}
                >
                  <Table size="small" sx={{ minWidth: 320 }}>
                    <TableBody>
                      {activeProcessesWarning.names.map((p) => {
                        const user = p.user ?? p;
                        const fullName =
                          [user.firstname, user.lastname]
                            .map((s) => (s || "").trim())
                            .filter(Boolean)
                            .join(" ") || "";
                        const initials =
                          [user.firstname, user.lastname]
                            .map((s) => s?.trim()?.[0]?.toUpperCase() || "")
                            .join("") || "?";
                        const hasUser = fullName.length > 0;
                        return (
                          <TableRow
                            key={p.id}
                            id={`depublish-active-process-row-${p.id}`}
                            hover
                            sx={{
                              "&:last-of-type td, &:last-of-type th": {
                                borderBottom: 0,
                              },
                            }}
                          >
                            <TableCell sx={{ width: 56, py: 1 }}>
                              <Avatar
                                sx={{
                                  width: 32,
                                  height: 32,
                                  bgcolor: hasUser
                                    ? "primary.main"
                                    : "grey.400",
                                  color: "common.white",
                                  fontSize: 14,
                                  fontWeight: 600,
                                }}
                              >
                                {hasUser ? (
                                  initials
                                ) : (
                                  <PersonOutline fontSize="small" />
                                )}
                              </Avatar>
                            </TableCell>
                            <TableCell sx={{ py: 1 }}>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 500 }}
                              >
                                {p.name}
                              </Typography>
                            </TableCell>
                            <TableCell
                              align="right"
                              sx={{ py: 1, whiteSpace: "nowrap" }}
                            >
                              <Typography
                                variant="caption"
                                color={
                                  hasUser ? "text.primary" : "text.secondary"
                                }
                                sx={{ fontStyle: hasUser ? "normal" : "italic" }}
                              >
                                {hasUser
                                  ? fullName
                                  : getTranslation(
                                      translations,
                                      "generic.unassigned.caption"
                                    ) || "Unassigned"}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              id="depublish-active-cancel-btn"
              onClick={cancelWarning}
              color="primary"
            >
              {getTranslation(translations, "generic.no.caption")}
            </Button>
            <Button
              id="depublish-active-proceed-btn"
              onClick={confirmWarning}
              color="primary"
              disabled={activeProcessesWarning.loading}
            >
              {getTranslation(translations, "generic.yes.caption")}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openSaveAsDialog}
          onClose={() => setOpenSaveAsDialog(false)}
        >
          <form>
            <DialogHeader onClose={() => setOpenSaveAsDialog(false)}>
              {getTranslation(translations, "pm.label.choose_name")}
            </DialogHeader>
            <DialogContent>
              <Grid container mt={0} spacing={2}>
                <Grid item>
                  <TextField
                    id="saveas-field"
                    value={values.saveAsName}
                    onChange={({ target }) =>
                      changeHandler("saveAsName", target.value)
                    }
                    error={Boolean(
                      touched.saveAsName && lightErrors.saveAsName
                    )}
                    helperText={touched.saveAsName && lightErrors.saveAsName}
                    size="small"
                    label={getTranslation(
                      translations,
                      "pm.label.process_name"
                    )}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Stack direction="row" justifyContent="flex-end" spacing={2}>
                <Button>
                  {getTranslation(translations, "generic.button.cancel")}
                </Button>
                <Button
                  id="saveas-confirm-btn"
                  variant="contained"
                  type="submit"
                  disabled={!isValid}
                  onClick={async (e) => {
                    e.preventDefault();
                    if (bpmnModeler) {
                      const modeling = bpmnModeler.get("modeling");
                      const element = bpmnModeler.get("elementRegistry");
                      const newErrorElement = errors
                        .map((error: any) => {
                          if (error.designerid === "") return undefined;
                          return element.get(error.designerid);
                        })
                        .filter((el: any) => el);

                      modeling.setColor(newErrorElement, null);
                      bpmnModeler
                        .saveXML({ format: true })
                        .then((data: any) => {
                          saveXmlAs(data.xml);
                        });
                    }
                  }}
                >
                  {getTranslation(translations, "pm.button.save_as")}
                </Button>
              </Stack>
            </DialogActions>
          </form>
        </Dialog>
      </Box>
      <ProcessModelSchema
        open={defineData}
        setOpen={setDefineData}
        onSave={onSaveSchema}
        schema={schema}
        lanes={visibilityElements.lanes}
        tasks={visibilityElements.tasks}
        // Solo un modello salvato ha un id con cui il server può validare una
        // formula: in creazione l'anteprima non si può chiedere, e lo dice.
        modelId={idToUse ? String(idToUse) : undefined}
        // I registri locali appartengono al modello: la master li amministra da
        // qui, ed è la spec a volerli in questo posto (D08).
        organizationId={
          selectedOrganization?.id ? String(selectedOrganization.id) : undefined
        }
      />

      {/* L'impatto di una modifica allo schema.
          Il salvataggio resta **sospeso** finche' non si conferma: una modifica
          che nasconde un campo a chi lo stava compilando, o che rende
          obbligatorio qualcosa che nessuno ha, va vista prima — non scoperta
          dopo, quando i processi gia' avviati ne pagano le conseguenze. */}
      <ImpactDialog
        open={impatto !== null}
        field={null}
        impact={impatto}
        loading={impattoLoading}
        // L'analisi cita i campi per id: la label è quella che il progettista
        // ha davanti nella bozza che sta salvando, e in coda resta lo schema
        // salvato per i campi che la bozza non ha più (una rimozione).
        fields={[...(pendingSchema?.rows ?? []), ...schema]}
        onConfirm={applicaSchemaConfermato}
        onClose={() => {
          // Chiudere senza confermare **non** salva: l'operazione resta
          // validata e mai applicata, che e' lo stato in cui deve restare.
          setImpatto(null);
          setPendingSchema(null);
        }}
      />
      <AssociationDialog
        open={associations}
        setOpen={setAssociations}
        onReassociate={(data) => {
          if (data.success) {
            // processModelsRef.current.savedProcessModel = data.model;
            originalXml.current = data.model;
            bpmnModeler?.importXML(data.model);
            if (data.responsemessage) {
              sendSnack({
                message: data.responsemessage,
                type: "success",
              });
            }
            setAssociations(null);
          }
        }}
        getProcessModel={async () => {
          const data = await bpmnModeler?.saveXML({ format: true });
          return {
            entities: [],
            idorganization: selectedOrganization?.id as number,
            model: data?.xml || "",
            extensionelements: getRequestBodyForExtensionElements(),
            extensionflownodes: processModelData.extensionflownodes,
            extensionswimlanes: processModelData.extensionswimlanes,
            extensionsubprocesses: extensionSubprocesses,
            modeltype: 0,
            name: processModelName,
            version: 0,
            creation: processModelData.creation || "",
            id: processModelData.id,
          };
        }}
      />
      <InputPopUp
        labels={{
          title: getTranslation(translations, "generic.model_name.caption"),
          inputLabel: getTranslation(
            translations,
            "generic.insert_model_name.caption"
          ),
        }}
        callback={exportModel}
        open={nameModelPopUp}
        onClose={() => setNameModelPopUp(false)}
      />
    </React.Fragment>
  );
};
export default NewProcessModule;
